import backendClient from 'api/backendClient';
import { GadsFilterParams } from 'model/googleAds/googleAds.request';
import { HourlyCoCResponse, HighestCostKeywordsResponse, LowestConvKeywordsResponse } from 'model/googleAds/googleAds.response';
import { CampaignOption, AdGroupOption, GadsSyncStatus } from 'model/googleAds/googleAds.model';

function buildQuery(params: GadsFilterParams): string {
  const parts: string[] = [];
  if (params.date_start) parts.push(`date_start=${encodeURIComponent(params.date_start)}`);
  if (params.date_end) parts.push(`date_end=${encodeURIComponent(params.date_end)}`);
  if (params.campaign_id) parts.push(`campaign_id=${encodeURIComponent(params.campaign_id)}`);
  if (params.ad_group_id) parts.push(`ad_group_id=${encodeURIComponent(params.ad_group_id)}`);
  if (params.limit) parts.push(`limit=${params.limit}`);
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}

export async function getHourlyCoC(params: GadsFilterParams): Promise<HourlyCoCResponse> {
  return backendClient.get<HourlyCoCResponse>(`/api/v1/google-ads/hourly-coc${buildQuery(params)}`);
}

export async function getHighestCostKeywords(params: GadsFilterParams): Promise<HighestCostKeywordsResponse> {
  return backendClient.get<HighestCostKeywordsResponse>(`/api/v1/google-ads/keywords/highest-cost${buildQuery(params)}`);
}

export async function getLowestConvKeywords(params: GadsFilterParams): Promise<LowestConvKeywordsResponse> {
  return backendClient.get<LowestConvKeywordsResponse>(`/api/v1/google-ads/keywords/lowest-conversion${buildQuery(params)}`);
}

export async function getCampaigns(): Promise<CampaignOption[]> {
  return backendClient.get<CampaignOption[]>('/api/v1/google-ads/campaigns');
}

export async function getAdGroups(campaignId?: string): Promise<AdGroupOption[]> {
  const query = campaignId ? `?campaign_id=${encodeURIComponent(campaignId)}` : '';
  return backendClient.get<AdGroupOption[]>(`/api/v1/google-ads/ad-groups${query}`);
}

export async function getSyncStatus(): Promise<GadsSyncStatus> {
  return backendClient.get<GadsSyncStatus>('/api/v1/google-ads/sync/status');
}
